import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=38ced652&scoped=true&lang=html&"
import script from "./settings.vue?vue&type=script&lang=js&"
export * from "./settings.vue?vue&type=script&lang=js&"
import style0 from "./settings.vue?vue&type=style&index=0&id=38ced652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ced652",
  null
  
)

component.options.__file = "settings.vue"
export default component.exports